<template>
  <div class="d-flex">
    <div class="col-left">
      <user-card-container />
      <notifications-container :readonly="true" />
    </div>
    <div class="col-center">
      <activity-container />
    </div>
  </div>
</template>
<script>
import UserCardContainer from '@/components/Widgets/UserCardContainer';
import NotificationsContainer from '@/components/Widgets/NotificationsContainer';
import ActivityContainer from '@/components/Widgets/ActivityContainer';

export default {
  components: {
    UserCardContainer,
    NotificationsContainer,
    ActivityContainer,
  },
  mounted() {
    this.$store.dispatch('profiles/fetchItem', this.$store.state.account.user.profile.pk);
  },
};
</script>
<style lang="scss" scoped>
$col-width: 220px;
.col-left{
  width: $col-width;
  @media screen and (min-width: 1055px){
    width: 265px;
  }
}
.col-center{
  width: 100%;
  margin-left: $grid-gutter-width;
}
</style>
